import cloneDeep from "lodash-es/cloneDeep";

const state = {
  searchTerm: null,
  recentSearches: [],
  searchRecommendations: [],
  isSearchOpen: false,
};

const mutations = {
  setSearchTerm(state, value) {
    state.searchTerm = value;
  },
  setRecentSearch(state, value) {
    state.recentSearches = value;
  },
  setSearchOpenState(state, value) {
    state.isSearchOpen = value;
  },
  setSearchRecommendations(state, value) {
    state.searchRecommendations = value;
  },
};

const getters = {
  orderedRecentSearches: (state) => {
    const recentSearchesCloned = cloneDeep(state.recentSearches) || [];

    const orderedSearches = recentSearchesCloned.sort(
      (a, b) => b.date - a.date
    );

    return orderedSearches.reverse();
  },
  searchRecommendationsWithStaticHeadings(state) {
    const reccs = cloneDeep(state.searchRecommendations) || {};
    const searchTerm = state.searchTerm;

    Object.keys(reccs).forEach((key) => {
      if (key === "searchpage-nosto-1") {
        reccs[key].title = `CUSTOMERS WHO SEARCHED "${searchTerm}" VIEWED`;
      }
      if (key === "searchpage-nosto-2") {
        reccs[key].title = "Products You Recently Viewed";
      }
      if (key === "searchpage-nosto-3") {
        reccs[key].title = "YOU MIGHT ALSO LIKE";
      }
    });

    return reccs;
  },
};

const actions = {
  fetchRecentSearches({ commit }) {
    const localStorageRecentSearches = JSON.parse(
      localStorage.getItem("shopifyRecentSearches")
    );

    if (localStorageRecentSearches) {
      commit("setRecentSearch", localStorageRecentSearches);
    }
  },
  addSearchTerm({ dispatch, commit }, value) {
    dispatch("fetchRecentSearches");
    commit("setSearchTerm", value);
    dispatch("nostoSearch", value);
    dispatch("addRecentSearch", value);
  },
  nostoSearch({ commit }, value) {
    // eslint-disable-next-line no-undef
    nostojs((api) => {
      api
        .defaultSession()
        .viewSearch(value)
        .setPlacements(["searchpage-nosto-3", "searchpage-nosto-2"])
        .load()
        .then((data) => {
          commit("setSearchRecommendations", data.recommendations);
        });
    });
  },
  clearSearchTerm({ commit }) {
    commit("setSearchTerm", null);
    commit("setSearchRecommendations", null);
  },
  removeRecentSearch({ commit, state, dispatch }, item) {
    const recentSearches = cloneDeep(state.recentSearches) || [];

    const index = recentSearches.findIndex((recentSearch) => {
      return recentSearch.date === item.date;
    });

    recentSearches.splice(index, 1);

    commit("setRecentSearch", recentSearches);
    dispatch("setLocationStorage", recentSearches);
  },
  addRecentSearch({ commit, state, dispatch }, value) {
    const recentSearches = cloneDeep(state.recentSearches) || [];
    const maxRecentSearches = 3;

    recentSearches.push({
      date: new Date(),
      value,
    });

    let limitedRecentSearches = recentSearches;
    const sliceAmount = Math.max(recentSearches.length - maxRecentSearches);
    if (sliceAmount > 0) {
      limitedRecentSearches = recentSearches.slice(sliceAmount);
    }

    commit("setRecentSearch", limitedRecentSearches);
    dispatch("setLocationStorage", limitedRecentSearches);
  },
  setLocationStorage(context, value) {
    localStorage.setItem("shopifyRecentSearches", JSON.stringify(value));
  },
  setSearchOpen({ commit }, value) {
    commit("setSearchOpenState", value);
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
